// src/components/profile/modals/TermsModal.jsx
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import useModalHistory from '../../../hooks/useModalHistory';

const TermsModal = ({ show, onHide, onAccept }) => {
  const [termsAccepted, setTermsAccepted] = useState(false);

      useModalHistory(show, onHide, 'profile-terms-modal');

  
  // Handle checkbox change
  const handleCheckboxChange = (e) => {
    setTermsAccepted(e.target.checked);
  };
  
  // Handle acceptance
  const handleAccept = () => {
    // Only proceed if terms are accepted
    if (termsAccepted) {
      // Store acceptance in session storage
      sessionStorage.setItem('paymentTermsAccepted', 'true');
      
      // Call the onAccept callback
      if (onAccept) {
        onAccept();
      }
      
      // Reset state
      setTermsAccepted(false);
    }
  };
  
  // Reset checkbox when modal is closed
  const handleClose = () => {
    setTermsAccepted(false);
    onHide();
  };
  
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
    >
      <Modal.Header className="bg-dark text-white">
        <Modal.Title>BitMobile Payment Terms and Conditions</Modal.Title>
        <Button 
          variant="link" 
          className="close text-white" 
          onClick={handleClose}
        >
          <span aria-hidden="true">&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div 
          className="terms-content text-white"
          style={{ maxHeight: '50vh', overflowY: 'auto' }}
        >
          <h4>1. Payment Authorization</h4>
          <p>By proceeding with the payment, you authorize BitMobile to charge the agreed amount to your chosen payment method. You confirm that you are the authorized holder of the payment method used.</p>
          
          <h4>2. Subscription Terms</h4>
          <p>BitMobile operates on a yearly subscription model that <strong>does not automatically renew</strong>. Subscription payments must be made manually on the Profile &gt; Account page.</p>
          
          <h4>3. Upgrades and Downgrades</h4>
          <p>Users on the Basic plan can upgrade to the Plus plan at any time, with pricing prorated according to the remaining days of the subscription. Plus plan users can downgrade to Basic in the final 30 days of their subscription, provided any Endowment data has been deleted.</p>
          
          <h4>4. No Refunds</h4>
          <p>Due to the nature of our services, <strong>no refunds</strong> are permitted once a payment has been completed. Please review our policies and terms before making any purchase.</p>
          
          <h4>5. Security</h4>
          <p>We use industry-standard encryption to protect your payment information. However, no method of electronic storage or transmission is 100% secure, and we cannot guarantee absolute security.</p>
          
          <h4>6. Currency and Fees</h4>
          <p>All payments are processed in the currency specified at checkout. Any currency conversion fees or additional bank charges are your responsibility.</p>
          
          <h4>7. Changes to Terms</h4>
          <p>We reserve the right to modify these payment terms at any time. Continued use of our services after such changes constitutes your acceptance of the new terms.</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-block">
        <div className="custom-footer-content">
          <Form.Group controlId="acceptTerms" className="mb-3">
            <Form.Check
              type="checkbox"
              label="I have read and accept the Payment Terms and Conditions"
              checked={termsAccepted}
              onChange={handleCheckboxChange}
              className="custom-checkbox"
            />
          </Form.Group>
          
          <div className="d-flex justify-content-between">
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            
            <Button
              variant="success"
              onClick={handleAccept}
              disabled={!termsAccepted}
            >
              Accept & Proceed to Payment
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;